import { TextLink } from '@snowflake/core-ui';
import React from 'react';

const TERMS_HREF =
  'https://www.snowflake.com/en/legal/terms-of-service/self-service-on-demand-terms-of-service/';
const PRIVACY_HREF = 'https://www.snowflake.com/en/legal/privacy-policy/';

export const StartupOfferTerms = () => {
  return (
    <div className="startup-offer-terms">
      <h3>Program details</h3>
      <p>This offer is limited to the first 500 approved Participants.</p>
      <p>
        Each applicant whose application Snowflake approves (&quot;Participant&quot;) will receive
        one CoCo subscription at no charge for 12 months starting from the completion of the signup
        process after the applicant is notified they are selected as a Participant (the
        &quot;Promotional Period&quot;).
      </p>
      <p>No payment method is required to enroll and to participate in the offer.</p>
      <p>
        Participants may cancel their subscription at any time during the Promotional Period. A
        Participant who cancels will not be eligible to reapply for or participate in this offer
        again.
      </p>
      <p>
        At the end of the Promotional Period, the subscription will be suspended and will not
        automatically convert to a paid subscription. To continue using CoCo after the Promotional
        Period, the Participant must add a valid payment method. Continued use will then be billed
        at Snowflake&apos;s then current rates.
      </p>
      <h3>Terms of service</h3>
      <p>
        By applying, and/or if subsequently selected as a Participant, you agree to the following
        Terms and Conditions:
      </p>
      <p>
        You agree to <TextLink href={TERMS_HREF}>Snowflake Self Service On Demand Terms</TextLink>{' '}
        and Snowflake&apos;s <TextLink href={PRIVACY_HREF}>Privacy Notice</TextLink>, which are
        incorporated in their entirety here.
      </p>
      <p>
        This offer is limited to one subscription per person, is non-transferable, and has no cash
        value. It may not be sold, assigned, shared, or otherwise transferred, and may not be used
        for or on behalf of any company, organization, or other third party. Cannot be combined with
        any other promotion or offer. All applications are subject to eligibility review and
        approval by Snowflake at its sole discretion.
      </p>
      <p>
        Participant grants Snowflake the right to identify the Participant as a participant in this
        offer — including by name, GitHub username, and/or associated open-source project — in
        Snowflake&apos;s communications, case studies, and marketing materials. Any co-marketing
        activity beyond this identification is voluntary and subject to Participant&apos;s prior
        consent. Participant may withdraw this permission on a going-forward basis by contacting
        Snowflake.
      </p>
      <p>
        Snowflake reserves the right to modify, suspend, or terminate this offer, including any
        subscription granted under it, at any time and at its sole discretion, with or without
        notice, to the extent permitted by applicable law.
      </p>
      <p>
        Meeting the stated eligibility criteria is a minimum requirement and does not guarantee
        approval. Snowflake may, at its sole discretion, decline, suspend, or revoke any application
        or subscription that it (a) determines is associated with breach of these terms, misuse,
        fraudulent, duplicate, inflated, or otherwise bad-faith activity — including the creation of
        multiple accounts or applications to circumvent the one-subscription-per-person limit, even
        where the stated eligibility criteria appear to be met, or (b) determines Participant was
        not, or is no longer, eligible.
      </p>
      <p>
        This offer is available only to Participants located in, and who will use CoCo in, countries
        where Snowflake trial accounts are available. The offer is void where prohibited and is not
        available to any person or entity that is located in, organized under the laws of, or
        ordinarily resident in any country or territory subject to comprehensive U.S. or other
        applicable trade sanctions or embargoes, or that is identified on any applicable
        restricted-party or denied-party list. By applying, Participant represents that they are not
        subject to any such restriction and that their participation complies with all applicable
        export control and economic sanctions laws.
      </p>
      <p>
        This offer is not available to Snowflake employees, contractors, or personnel of
        Snowflake&apos;s affiliates, or to their immediate family members or households.
      </p>
      <p>
        In the event of any conflict between these offer Terms and Conditions and the Snowflake Self
        Service On Demand Terms, these Terms and Conditions control with respect to this offer; the
        Snowflake Self Service On Demand Terms govern all other use of the Service.
      </p>
    </div>
  );
};
